import { Injectable } from "@angular/core";
import { distinctUntilChanged, map } from "rxjs/operators";

// eslint-disable-next-line no-restricted-imports
import { NgxPermissionsService } from "ngx-permissions";

// NOTE: This service is needed to create one single instance of NgxPermissionsService (by default it is not provided in root)
// in whole feature-flags module.
@Injectable({ providedIn: "root" })
export class SharedNgxPermissionsService extends NgxPermissionsService {}

@Injectable({
    providedIn: "root",
})
export class FeatureFlagsService {
    constructor(private permissionsService: SharedNgxPermissionsService) {}

    public addFlags(flag: string | string[]) {
        this.permissionsService.addPermission(flag);
    }

    public setFlags(flags: string | string[]) {
        const flagsArray = Array.isArray(flags) ? flags : [flags];

        this.permissionsService.loadPermissions(flagsArray);
    }

    public isFeatureEnabled(feature: string) {
        return this.permissionsService.permissions$.pipe(
            map((permissions) => !!permissions[feature]),
            distinctUntilChanged()
        );
    }

    public isAnyFeatureEnabled(features: string[]) {
        return this.permissionsService.permissions$.pipe(
            map((permissions) => features.some((feature) => !!permissions[feature])),
            distinctUntilChanged()
        );
    }

    public getCurrentFeatureState(feature: string) {
        return !!this.permissionsService.getPermission(feature);
    }
}
